import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// A tab of the native tab bar shows a count as badge (cart: bookings in the cart, bookings: bookings that need action).
// Every page load and every turbo stream that replaces this element sends the current count.
export default class extends BridgeComponent {
  static component = "tab-badge"

  connect() {
    super.connect()

    const tab = this.bridgeElement.bridgeAttribute("tab")
    const count = Number(this.bridgeElement.bridgeAttribute("count")) || 0
    this.send("connect", { tab, count })
  }
}
